module.exports = __webpack_public_path__ + "img/pose-m-1.f293cfd1.png";